<template>
  <DataTable
    class="tableHeaderStyle"
    :value="orders"
    stripedRows
    tableStyle="min-width: 50rem"
    ref="dt"
    :exportFilename="exportFileName"
  >
    <!-- <Column sortable field="index" header="#" /> -->
    <Column sortable field="date" header="Date" />

    <Column sortable field="orderNumber" header="Order Number">
      <template #body="data">
        <router-link
          :to="{
            name: 'Order Details',
            query: { id: data.data.id },
          }"
        >
          <p>{{ data.data.orderNumber }}</p>
        </router-link>
      </template>
    </Column>

    <Column sortable field="productId" header="Product">
      <template #body="order">
        <ProductType :type="order.data.depotProductName" />
      </template>
    </Column>
    <Column sortable field="price" header="Price">
      <template #body="order">
        {{ amountFormat(order.data.price) }}
      </template>
    </Column>
    <Column sortable field="quantity" header="Quantity">
      <template #body="order">
        {{ formatNumber(order.data.quantity) }}
      </template>
    </Column>

    <Column field="totalAmount" header="Amount" :sortable="true">
      <template #body="order">
        {{ amountFormat(order.data.totalAmount) }}
      </template>
    </Column>

    <Column header="Status">
      <template #body="order">
        <PaymentStatusType :type="order.data.status" />
      </template>
    </Column>

    <template #empty>
      <div class="pt-4 text-center">
        <EmptyList :type="'Order'" />
      </div>
    </template>
  </DataTable>

  <Pagination :paginationData="pagination" :handler="handlePagination" />
</template>

<script>
//utils
import { amountFormat, formatNumber } from "@/utils/formatter";

//libraries
import Column from "primevue/column";
import DataTable from "primevue/datatable";

//components

import ProductType from "@/components/UI/ProductTypes";
import Pagination from "@/components/UI/Pagination/index.vue";
import DTButton from "@/components/UI/Buttons/DTButton.vue";
import PaymentStatusType from "@/components/UI/PaymentStatusTypes";
import EmptyList from "@/components/Empty/index.vue";

export default {
  name: "DepotOrders",
  props: [
    "details",
    "orders",
    "exportFileName",
    "pagination",
    "handlePagination",
  ],
  components: {
    Column,
    DTButton,
    DataTable,
    Pagination,
    ProductType,
    PaymentStatusType,
    EmptyList,
  },
  data() {
    return {
      amountFormat: amountFormat,
      formatNumber: formatNumber,
    };
  },
  mounted() {},
  methods: {
    exportTable() {
      this.$refs.dt.exportCSV();
    },
  },
};
</script>

<style></style>
